import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { fetchProductList as fetchProducts } from '../services/api'
import { removeCache } from '../services/cache'

const ProductListContext = React.createContext({
  formModalVisible: false,
  productList: [],
  selectedProduct: null,
  setFormModalVisible: () => {
  },
  setProductList: () => {
  },
  setSelectedProduct: () => {
  },
  fetchProductList: () => {
  },
  isLoading: false
})

const ProductListContextProvider = ({ children, singleProduct = null }) => {
  const [formModalVisible, setFormModalVisible] = useState(false)
  const [productList, setProductList] = useState([])
  const [selectedProduct, setSelectedProduct] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  // const [productAPIVersion, setProductAPIVersion] = useState(useCache(null, 'productAPIVersion'))
  // const [productAPIVersionUpdated, setProductAPIVersionUpdated] = useState(false)
  //
  // const previousProductAPIVersion = usePrevious(productAPIVersion)

  // useEffect(() => {
  //   const _getProductAPIVersion = async () => {
  //     try {
  //       setIsLoading(true)
  //
  //       const productAPIVersion = await getProductAPIVersion()
  //
  //       setProductAPIVersionUpdated(true)
  //       _setProductAPIVersion(productAPIVersion)
  //
  //       setIsLoading(false)
  //     } catch (err) {
  //       setIsLoading(false)
  //     }
  //   }
  //
  //   _getProductAPIVersion()
  // }, [])

  // useEffect(() => {
  //   if (productAPIVersionUpdated) {
  //     const thereIsNewVersion = previousProductAPIVersion !== productAPIVersion
  //
  //     if (thereIsNewVersion) _removeCache()
  //   }
  //
  //   /* eslint-disable-next-line react-hooks/exhaustive-deps */
  // }, [productAPIVersionUpdated, productAPIVersion])

  useEffect(() => {
    _removeCache()

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [productList, singleProduct])

  const fetchProductList = async () => {
    try {
      setIsLoading(true)

      const products = await fetchProducts()

      setProductList(products)
      setIsLoading(false)
    } catch (err) {
      setIsLoading(false)
    }
  }

  const _removeCache = () => {
    removeCache(singleProduct)
    productList.map(({ name }) => removeCache(name))
  }

  // const _setProductAPIVersion = (version) => {
  //   setCache('productAPIVersion', version)
  //   setProductAPIVersion(version)
  // }

  const values = {
    formModalVisible,
    productList,
    selectedProduct,
    setFormModalVisible,
    setProductList,
    setSelectedProduct,
    fetchProductList,
    isLoading
  }

  return (
    <ProductListContext.Provider value={values}>
      {children}
    </ProductListContext.Provider>
  )
}

ProductListContextProvider.propTypes = {
  children: PropTypes.any,
  singleProduct: PropTypes.string
}

export {
  ProductListContext,
  ProductListContextProvider
}
